import { isEmpty } from '@/helpers'
import { useLangStore } from '@/stores/app/lang'
import { usePageStore } from '@/stores/app/page'
import { usePopupStore } from '@/stores/popup'
import { useMenuStore } from '@/stores/gallery/menu'

export function useAppFeature() {
  // -----------------------------------------------
  function setupAppConfig(options) {
    if (!isEmpty(options.startupLang)) {
      const langStore = useLangStore()
      langStore.$patch({ lang: options.startupLang })
      document.documentElement.setAttribute('lang', options.startupLang)
    }

    if (!isEmpty(options.startupPage)) {
      const pageStore = usePageStore()
      pageStore.$patch({ page: options.startupPage })
    }

    if (!isEmpty(options.startupPopup)) {
      const popupStore = usePopupStore()
      popupStore.$patch({ popup: options.startupPopup })
    }

    if(JSON.parse(options.enableAllMenus)) {
      useMenuStore().enableAllMenus()
    }

  }

  // -----------------------------------------------
  return { setupAppConfig }
}
